<template>
  <v-content>
    <!-- Parallax -->
    <section v-if="$vuetify.breakpoint.smAndUp" class="elevation-10">
      <v-parallax src="public/dividers/div_5.png" height="400">
        <v-layout column align-center justify-center class="white--text">
          <div v-lang.pricingDes class="font-title text-xs-center"></div>
        </v-layout>
      </v-parallax>
    </section>
    <section v-else class="elevation-10">
      <v-parallax src="public/dividers/div_5_min.png" height="200">
        <v-layout column align-center justify-center class="white--text mt-5">
          <div v-lang.pricingDes class="font-title-mobile text-xs-center"></div>
        </v-layout>
      </v-parallax>
    </section>
    <!-- Content -->
    <section>
      <!-- Pricing Virtual -->
      <v-layout row wrap justify-center align-center class="mt-4">
        <v-flex v-lang.pricingTitle1 xs12 class="font-heading" text-xs-center></v-flex>
        <v-flex v-lang.pricingTitle1Des xs12 style="text-align: justify;" text-xs-center class="mt-3 mb-3 mx-4"></v-flex>
      </v-layout>
      <v-layout column wrap class="mt-3 mb-5">
        <v-container grid-list-xl>
          <v-layout row wrap align-center justify-center>
            <v-flex md4>
              <v-card class="elevation-10 cyan">
                <v-card-text class="text-xs-center font-title">
                  <p class="mb-0">{{priceSmall}}
                    <sup class="font-subtitle">{{currency}}</sup>
                  </p>
                  <p v-lang.month class="font-heading mb-0"></p>
                </v-card-text>
                <!-- <v-card-title v-lang.small class="font-heading justify-center py-0"></v-card-title> -->
                <v-card-text v-lang.smallDes class="text-xs-center" style="height: 100px"></v-card-text>
              </v-card>
            </v-flex>
            <v-flex md4>
              <v-card class="elevation-10 blue">
                <v-card-text class="text-xs-center font-title">
                  <p class="mb-0">{{priceMedium}}
                    <sup class="font-subtitle">{{currency}}</sup>
                  </p>
                  <p v-lang.month class="font-heading mb-0"></p>
                </v-card-text>
                <!-- <v-card-title v-lang.medium class="font-heading justify-center py-0"> </v-card-title> -->
                <v-card-text v-lang.mediumDes class="text-xs-center" style="height: 100px"></v-card-text>
              </v-card>
            </v-flex>
            <v-flex md4>
              <v-card class="elevation-10 indigo">
                <v-card-text class="text-xs-center font-title">
                  <p class="mb-0">{{priceLarge}}
                    <sup class="font-subtitle">{{currency}}</sup>
                  </p>
                  <p v-lang.month class="font-heading mb-0"></p>
                </v-card-text>
                <!-- <v-card-title v-lang.large class="font-heading justify-center py-0"></v-card-title> -->
                <v-card-text v-lang.largeDes class="text-xs-center" style="height: 100px"></v-card-text>
              </v-card>
            </v-flex>
          </v-layout>
        </v-container>
      </v-layout>
      <v-layout row wrap justify-center align-center class="mt-0 mb-5 pb-5 pt-0">
        <v-flex xs12 v-lang.pricingText3 style="text-align: justify;" text-xs-center class="mx-4"></v-flex>
        <v-flex><br></v-flex>
        <v-flex xs12 v-lang.pricingText4 style="text-align: justify;" text-xs-center class="mx-4"></v-flex>
      </v-layout>
    </section>
    <!-- Footer -->
    <c-footer></c-footer>
  </v-content>
</template>

<script>
import CFooter from "./Footer";
export default {
  data() {
    return {
      priceSmall: 0,
      priceMedium: 0,
      priceLarge: 0,
      currency: ""
    };
  },
  methods: {
    priceSel: function() {
      if (this.language == "sv") {
        this.priceSmall = 1940;
        this.priceMedium = 2780;
        this.priceLarge = 2980;
        this.currency = "kr";
      } else {
        this.priceSmall = 119;
        this.priceMedium = 280;
        this.priceLarge = 299;
        this.currency = "€";
      }
    }
  },
  components: {
    CFooter
  },
  updated() {
    this.priceSel();
  },
  mounted() {
    this.priceSel();
  }
};
</script>


// WEBPACK FOOTER //
// src/components/Pricing.vue